import { LocationSummary } from "@nimble/data-service-client/types";

/**
 * Formats an address for Google Maps URL
 * @param address - Object containing address components
 * @returns Google Maps URL with encoded address
 *
 * @example
 * const directionsUrl = formatAddressForMaps({
 *   line_1: "123 Main St",
 *   city: "Kansas City",
 *   state: "MO"
 * });
 * // Returns: "https://maps.google.com/?q=123%20Main%20St%2C%20Kansas%20City%2C%20MO"
 */
export function formatAddressForMaps(address: LocationSummary): string {
  const addressString = `${address.line_1}, ${address.city}, ${address.state}`;
  return `https://maps.google.com/?q=${encodeURIComponent(addressString)}`;
}
